import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=5a8c7982&scoped=true&"
import script from "./CourseIndex.vue?vue&type=script&lang=ts&"
export * from "./CourseIndex.vue?vue&type=script&lang=ts&"
import style0 from "./CourseIndex.vue?vue&type=style&index=0&id=5a8c7982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c7982",
  null
  
)

export default component.exports